"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

const MAX_RECENT = 10;
const TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

export interface RecentEntry {
  fileId: string;
  openedAt: number;
}

interface RecentState {
  entries: RecentEntry[];
  record: (fileId: string) => void;
  topN: (n?: number) => RecentEntry[];
  clear: () => void;
}

/**
 * Store de "archivos recientes" para el command palette.
 * Persiste en localStorage, TTL de 7 días, máximo 10 entradas.
 */
export const useRecentFilesStore = create<RecentState>()(
  persist(
    (set, get) => ({
      entries: [],
      record: (fileId) => {
        set((s) => {
          const filtered = s.entries.filter((e) => e.fileId !== fileId);
          return {
            entries: [{ fileId, openedAt: Date.now() }, ...filtered].slice(0, MAX_RECENT),
          };
        });
      },
      topN: (n = 5) => {
        const cutoff = Date.now() - TTL_MS;
        return get()
          .entries.filter((e) => e.openedAt > cutoff)
          .sort((a, b) => b.openedAt - a.openedAt)
          .slice(0, n);
      },
      clear: () => set({ entries: [] }),
    }),
    { name: "wiki-arsenal-recent-files" },
  ),
);
